import { useState } from 'react';
import { LocalStorage, KEYS } from '@/utils/LocalStorage';

const readKitType = (): string => {
  const localBootupState = LocalStorage.getItem(KEYS.BOOTUP);

  if (!localBootupState) {
    return '';
  }

  try {
    const parsedBootupState = JSON.parse(localBootupState);
    return parsedBootupState.kitType ?? '';
  } catch (error) {
    console.error('Failed to parse bootup state from local storage:', error);
    return '';
  }
};

export const useKitType = (): string => useState(readKitType)[0];
